import { api } from '@/lib/api';

export type WhatsAppMediaCategory = 'image' | 'video' | 'document';

export type WhatsAppMediaItem = {
  id: string;
  hospitalId: string;
  fileName: string;
  originalName: string;
  fileType: string;
  fileSize: number;
  mediaCategory: WhatsAppMediaCategory;
  publicUrl: string;
  uploadedById: string | null;
  uploadedByName: string | null;
  usageCount: number;
  campaignCount: number;
  lastUsedAt: string | null;
  createdAt: string;
};

export type WhatsAppMediaStats = {
  totalFiles: number;
  storageUsedBytes: number;
  imageCount: number;
  videoCount: number;
  documentCount: number;
  totalUsageCount: number;
  totalCampaignCount: number;
};

export const whatsappMediaApi = {
  upload: (file: File) => {
    const form = new FormData();
    form.append('file', file);
    return api.post<{ data: { mediaId: string; publicUrl: string; mediaCategory: string } }>(
      '/api/whatsapp/media/upload',
      form,
      { headers: { 'Content-Type': 'multipart/form-data' } }
    );
  },

  uploadFromUrl: (url: string) =>
    api.post<{ data: { mediaId: string; publicUrl: string; mediaCategory: string } }>(
      '/api/whatsapp/media/upload-from-url',
      { url }
    ),

  list: (params?: { category?: WhatsAppMediaCategory; search?: string }) =>
    api.get<{ data: { items: WhatsAppMediaItem[] } }>('/api/whatsapp/media', { params }),

  stats: () => api.get<{ data: WhatsAppMediaStats }>('/api/whatsapp/media/stats'),

  remove: (id: string) => api.delete(`/api/whatsapp/media/${id}`),

  validateUrl: (url: string, category?: WhatsAppMediaCategory) =>
    api.post<{ data: { ok: boolean; error?: string } }>('/api/whatsapp/media/validate-url', {
      url,
      category,
    }),

  getTemplateDefault: (templateName: string) =>
    api.get<{ data: { media: WhatsAppMediaItem | null } }>('/api/whatsapp/media/template-defaults', {
      params: { templateName },
    }),

  saveTemplateDefault: (templateName: string, mediaId: string) =>
    api.post('/api/whatsapp/media/template-defaults', { templateName, mediaId }),
};

export function formatMediaBytes(bytes: number): string {
  if (bytes < 1024) return `${bytes} B`;
  if (bytes < 1024 * 1024) return `${(bytes / 1024).toFixed(1)} KB`;
  return `${(bytes / (1024 * 1024)).toFixed(1)} MB`;
}

export function headerFormatToMediaCategory(
  format: string
): WhatsAppMediaCategory | null {
  const f = format.toUpperCase();
  if (f === 'IMAGE') return 'image';
  if (f === 'VIDEO') return 'video';
  if (f === 'DOCUMENT') return 'document';
  return null;
}
